/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { ReactNode } from "react"
import { Theme } from "../../../types"

type Props = {
    children: ReactNode
}

function ListItemActionContainer(props: Props) {
    return <div css={styles.root}>{props.children}</div>
}

export default ListItemActionContainer

const styles = {
    root: (theme: Theme) => css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex: 1;
        padding-left: ${theme.spaces.smallScale.s};
    `,
}
